import { render, staticRenderFns } from "./BillingReports.vue?vue&type=template&id=12b8c160&"
import script from "./BillingReports.vue?vue&type=script&lang=js&"
export * from "./BillingReports.vue?vue&type=script&lang=js&"
import style0 from "./BillingReports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BillingReports.vue"
export default component.exports